export const LOGIN_FORTY_DAYS_REVIEW_ALERT_ID = "login-forty-days-review-dialog-id";
